import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  map,
  Subject,
  take,
  takeUntil,
} from 'rxjs';
import { CommonModule } from '@angular/common';
import {RouterLink } from '@angular/router';
import { VehicleTypeOption } from '../vehicle-type-global-selection-block/vehicle-type-global-selection-block.component';
import { StateService } from '../../../../core/state/old/state.service';
import { GET_VEHICLE_TYPES } from '../vehicle-types.graphql';
import { VehicleTypeItem } from '../../../../graphql/generated/generated-types';
import { DataService } from '../../../../core/providers/data/data.service';
import { availableVehicleTypes, VehicleType, VehicleTypeLabel } from '../../../dialogs/add-vehicle-form/vehcle-type.interfaces';

@Component({
  selector: 'app-vehicle-type-global-selection-list',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './vehicle-type-global-selection-list.component.html',
  styleUrl: './vehicle-type-global-selection-list.component.scss'
})
export class VehicleTypeGlobalSelectionListComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject<void>();

  public vehicleTypeOptions: VehicleTypeOption[] = [
    { label: VehicleTypeLabel.Passenger, value: VehicleType.Passenger },
    { label: VehicleTypeLabel.Truck, value: VehicleType.Truck },
    { label: VehicleTypeLabel.Commercial, value: VehicleType.Commercial },
    { label: VehicleTypeLabel.Moto, value: VehicleType.Moto },
    { label: VehicleTypeLabel.ATV, value: VehicleType.ATV },
    { label: VehicleTypeLabel.Agro, value: VehicleType.Agro },
  ];

  public selectedVehicleTypeControl: FormControl = new FormControl(undefined);

  constructor(
    private stateService: StateService,
    private dataService: DataService,
  ) {
    this.subscribeToVehicleTypeStateChanges();
  }

  ngOnInit(): void {
    this.getVehicleTypes();
  }

    private getVehicleTypes() {
          this.vehicleTypeOptions = availableVehicleTypes.map((vehicleType: VehicleTypeItem) => ({
            label: vehicleType.name,
            value: vehicleType.slug,
            metadata: vehicleType
          }));

          return;
      this.dataService
        .query<any>(
          GET_VEHICLE_TYPES,
          {},
          'cache-and-network'
        )
        .pipe(
          map((response) => response.vehicleTypes),
          take(1)).subscribe({
            next: (response: VehicleTypeItem[]) => {
              this.vehicleTypeOptions = response.map((vehicleType: VehicleTypeItem) => ({
                label: vehicleType.name,
                value: vehicleType.slug,
                metadata: vehicleType
              }));
            },
          })
    }

  private subscribeToVehicleTypeStateChanges(): void {
    this.stateService
      .select((state) => state.selectedVehicleType)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((vehicleType: VehicleType | null) => {
        if (this.selectedVehicleTypeControl.value !== vehicleType) {
          this.selectedVehicleTypeControl.setValue(vehicleType, {
            emitEvent: false,
          });
        }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }






}
